import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { AuthViewWrapper } from "../../hocs/AuthViewWrapper";
import { authorization } from "@lubbezposrednio-frontend/core";
import { BottomButtonsSection } from "./components/BottomButtonsSection";
import { LoginForm } from "./components/LoginForm";
import { TwoFactorPanel } from "./components/TwoFactorPanel";

interface LoginViewProps {}

export const LoginView: React.FC<LoginViewProps> = observer(({}) => {
  useEffect(() => {
    document.title = "Logowanie";
    authorization.clearInputData();
    authorization.clearTwoFactorChallenge(); // nie pokazuj panelu 2FA ze starego (singleton)
  }, []);

  // 2FA: po poprawnym haśle backend zwraca wyzwanie → pokaż panel drugiego składnika.
  if (authorization.twoFactorChallenge) {
    return <TwoFactorPanel authorization={authorization} />;
  }

  return (
    <AuthViewWrapper
      authorization={authorization}
      buttonText="Zaloguj się"
      buttonColor="primary"
      title="Zaloguj się"
      subtitle="Zarządzaj swoimi głosowaniami. Do oddania głosu logowanie nie jest potrzebne."
      cyberspaceOAuth
      cyberidLogin
      bottomElement={<BottomButtonsSection />}
      submitAction={authorization.logIn}
    >
      <LoginForm authorization={authorization} />
    </AuthViewWrapper>
  );
});
